const constants = {
  PROCESS_DELIVERY_STEPS: {
    PROCESS_DELIVERY: "PROCESS_DELIVERY",
    DELIVERY_RECEIPT: "DELIVERY_RECEIPT",
  },
  PHONE_NUMBER_MASK: [
    "(",
    /\d/,
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
  ELEVEN_DIGITS_PHONE_NUMBER_MASK: [
    /\d/,
    "-",
    "(",
    /[1-9]/,
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
  RECEIVER_NAME_PARAMS: {
    placeholder: "Enter Receiver Name",
    format: /^\w{2}/, /* ll match anything with min 2 char*/
    capitalize: false,
  }
};

export default constants;
